import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//

import RecommendItem from '@/components/home/RecommendItem';
import GoodRead from '@/components/home/GoodRead';
import BrandWall from '@/components/home/BrandWall';
import GroupPurchaseCard from '@/components/GroupPurchaseCard/index';
export default {
  name: 'recommend-list',
  components: {
    RecommendItem: RecommendItem,
    GoodRead: GoodRead,
    BrandWall: BrandWall,
    GroupPurchaseCard: GroupPurchaseCard
  },
  props: {
    recommendList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultColor: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isRecommendABtest: {
      type: Number,
      default: 0
    }
  },
  watch: {},
  data: function data() {
    return {};
  },
  methods: {}
};